<template>
  <div class="guild-header-desktop">
    <v-card img="https://i.redd.it/tv6q8odyw4p51.jpg" color="rgba(25,25,25,1)">
      <v-row>
        <v-col cols="12" sm="7">
          <div class="pl-8">
            <v-card-title
              class="white--text font-weight-bold text-uppercase text-md-h2 text-h3 d-inline-block text-truncate"
              style="max-width: 80vw;"
              >{{ guildName }}</v-card-title
            >
            <v-card-text
              class="white--text font-weight-bold text-uppercase text-md-h3 text-h4 d-inline-block text-truncate"
              style="max-width: 80vw;"
              >{{ activeMembers }}</v-card-text
            >
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "GuildHeaderDesktop",
  props: {
    guildName: { type: String },
    activeMembers: { type: String }
  }
};
</script>

<style scoped>
</style>